import { useEffect, useState } from 'react'

export function useConnectionStatus(intervalMs: number = 2000) {
  const [isOnline, setIsOnline] = useState(navigator.onLine)

  useEffect(() => {
    const checkOnline = () => {
      const online = navigator.onLine
      if (online !== isOnline) {
        setIsOnline(online)
      }
    }

    const interval = setInterval(checkOnline, intervalMs)
    return () => clearInterval(interval)
  }, [isOnline, intervalMs])

  return isOnline
}
